// apps/spa/src/lib/color.ts
// Hex<->int color conversion helpers shared between EmbedEditor (form state in
// hex) and the API boundary (Discord embed.color is an int 0..0xFFFFFF).
//
// 03-03 (reminder editor) does the actual conversion at the form/save boundary:
//   load: intToHex(reminder.embedJson.color) -> form state
//   save: form.color -> hexToInt -> embedded int before stringify
//
// Both functions throw on invalid input. isValidHex is the safe predicate for
// ColorPicker's typed-input UI.

const HEX_RE = /^#?([0-9a-fA-F]{6})$/;

export function hexToInt(hex: string): number {
  const m = HEX_RE.exec(hex);
  if (!m) throw new Error(`Invalid hex: ${hex}`);
  return parseInt(m[1], 16);
}

export function intToHex(n: number): string {
  if (!Number.isInteger(n) || n < 0 || n > 0xffffff) {
    throw new Error(`Invalid color int: ${n}`);
  }
  return `#${n.toString(16).padStart(6, '0').toLowerCase()}`;
}

export function isValidHex(hex: string): boolean {
  return HEX_RE.test(hex);
}
